import { useEffect } from 'react';
import styled from 'styled-components';

import smallclock1 from '../../../images/loader/clock1.svg';
import smallclock2 from '../../../images/loader/clock2.svg';
import smallclock3 from '../../../images/loader/clock3.svg';
import smallclock4 from '../../../images/loader/clock4.svg';

export const StyledSmallLoader = styled.div`
  width: ${({ width }) => width || '120px'};
  height: ${({ height }) => height || '120px'};
  border-radius: 50%;
  background-size: cover;
  background-repeat: no-repeat;

  animation: loaderSmallAnimation 1s infinite;

  @keyframes loaderSmallAnimation {
    0% {
      background-image: url(${smallclock1});
    }
    25% {
      background-image: url(${smallclock2});
    }
    50% {
      background-image: url(${smallclock3});
    }
    75% {
      background-image: url(${smallclock4});
    }
    100% {
      background-image: url(${smallclock1});
    }
  }
`;

export const SmallLoader = ({ width, height }) => {
  useEffect(() => {
    const images = [smallclock1, smallclock2, smallclock3, smallclock4];

    images.forEach(src => {
      const img = new Image();
      img.src = src;
    });
  }, []);

  return <StyledSmallLoader width={width} height={height} />;
};